import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./style.scss";

const FormContainer = ({ title, children, onClose, isInForm, doubleSpacer = true }) => {
    const classes = classnames(
        "form-container",
        isInForm ? "light" : "dark",
    );
    return (
        <div className={classes}>
            <div className="cols-m">
                <div className="col">
                    <h4>{title}</h4>
                </div>
                <div className="col">
                    {onClose &&
                        <button
                            className="delete is-medium is-pulled-right"
                            aria-label="close"
                            onClick={onClose}
                        />
                    }
                </div>
            </div>
            {doubleSpacer ? <div className="spacer-double" /> : <div className="spacer" />}
            <div>
                {children}
            </div>
        </div>
    );
};


FormContainer.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onClose: PropTypes.func,
    isInForm: PropTypes.bool,
    doubleSpacer: PropTypes.bool
};

export default FormContainer;